import React, { useMemo } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { getChartColor } from "../../config/colors";


const SFGBarChart = ({ sfgStatusData }) => {
  const categories = sfgStatusData.map((item) =>
    item.class_name
      ? item.class_name
      : item.size_name
      ? item.size_name
      : item.gloves_type_name
  );
  const dataValues = sfgStatusData.map((item) => item.pairing_count);

  const seriesData = sfgStatusData.map((item) => ({
    y: item.pairing_count,
    color: getChartColor(
      item.class_name || item.size_name || item.gloves_type_name
    ), // Use the centralized function, considering different naming
  }));

  const options = useMemo(() => ({
    chart: {
      type: "column",
      height: 200,
      backgroundColor: "transparent",
    },
    exporting: {
      enabled: false,
    },
    title: { 
      text: "" 
    },
    xAxis: {
      categories,
      labels: {
        rotation: 0,
        align: "center",
        style: {
          fontSize: "12px",
          fontWeight: "500",
        },
      },
      lineColor: "#cccccc",
      tickLength: 0,
    },
    yAxis: {
      visible: false,
    },
    tooltip: {
      formatter: function () {
        return `${this.key} : <b>${this.y}</b>`;
      },
    },
    credits: { enabled: false },
    legend: { enabled: false },
    plotOptions: {
      column: {
        borderRadius: 5,
        pointPadding: 0.1,
        groupPadding: 0.1,
        colorByPoint: true, // ✅ Allows individual colors
      },
      series: {
        pointWidth: 40,
      },
    },
    series: [
      {
        data: seriesData,
      },
    ],
  }), [sfgStatusData]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default SFGBarChart;